// extracted by mini-css-extract-plugin
module.exports = {"button":"button-1oK5u","icon":"icon-2uOLV","description":"description-2CEC6"};